import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'wf-no-data-msg',
  templateUrl: './waffle-no-data-msg.component.html',
  styleUrls: ['./waffle-no-data-msg.component.scss'],
})
export class WaffleNoDataMsgComponent implements OnInit {
  @Input() msg: string = 'ListLengthZero';

  constructor() { }

  ngOnInit() {
  }

}
